import { LocationType } from 'features/forms/types'
import { _ } from 'utils'
import env from '../env'

export default Object.freeze({
    urlThumbnailDefault: 'https://secure.gravatar.com/avatar/8fbf5ffda6230029170d4bf05c9f332a?s=140&d=mm',

    // For https://twoppy.atlassian.net/browse/ORG-1399
    // In lite environment or debug env with search param /?liteVersion=true,
    // we will apply restrictions to the lite product
    isLite: env.liteVersion === 'true'
        || (env.debug && new URLSearchParams(window.location.search).get('liteVersion') === 'true'),

    contextualHelpBaseUrl: env.helpUrl,

    // We have to use function here because react-intl-universal doesn't work outside react components
    getLocationOptions: () => ([
        { label: _('location_type.virtual'), value: LocationType.VIRTUAL },
        { label: _('location_type.in_person'), value: LocationType.IN_PERSON },
        { label: _('location_type.hybrid'), value: LocationType.HYBRID },
    ])
})
